
import { LocalRequirement } from "../types";

export const researchLocalRequirements = async (location: string): Promise<LocalRequirement[]> => {
  try {
    const response = await fetch('/api/ai/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: `
        Research the specific legal licensing, permits, and insurance requirements for arboricultural tasks in ${location} and its surrounding 100-mile radius (including nearby AL and GA municipalities like Columbus, Phenix City, Auburn, Opelika, Macon).
        
        Focus on tasks like tree removal, pesticide application (PHC), and operation of heavy equipment.
        
        For each requirement, find the most relevant authority URL where a user could apply for the license or find more info.
        
        Respond with a JSON array of objects: { task, requirement, authority, penalty, applyUrl }
      `,
        model: 'gemini-3.6-flash'
      })
    });

    const data = await response.json();
    return JSON.parse(data.text || '[]');
  } catch (error) {
    console.error("Licensing Research Error:", error);
    return [];
  }
};
